import { Box, IconButton, Typography, ArrowBackIcon, ToggleButtonGroup, ToggleButton } from 'src/components';
import { useIsMobile } from 'src/hooks';
import { useTripMap } from 'src/utils';

export default function AnimationControlsHeader({ toggleVisualisationView }) {
    const isMobile = useIsMobile();

    const { pitch, setPitch } = useTripMap();

    const handlePitchChange = (event, newPitch) => {
        setPitch(newPitch);
    };

    return (
        <Box 
            style={{
                position: isMobile ? 'absolute' : 'relative',
                top: 0,
                left: isMobile ? 0 : '0',
                right: 0,
                height: 60,
                padding: '0 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: 'rgba(255,255,255,0.9)',
                borderBottom: '1px solid #ccc',
                zIndex: 20
            }}
            >
            <Box sx={{ width: 80, display: 'flex', justifyContent: 'flex-start' }}>
                <IconButton size="small" onClick={toggleVisualisationView}>
                    <ArrowBackIcon fontSize="small"/>
                </IconButton>
            </Box>

            <Typography variant="h6">Export</Typography>

            <Box sx={{ width: 80, display: 'flex', justifyContent: 'flex-end' }}>
                <ToggleButtonGroup
                    value={pitch}
                    exclusive
                    onChange={handlePitchChange}
                    size="small"
                    sx={{
                        backgroundColor: 'white',
                        borderRadius: 999,
                        boxShadow: 1,
                        p: 0.25,
                        '& .MuiToggleButton-root': {
                        fontSize: '0.75rem',
                        px: 1.5,
                        py: 0.25,
                        border: 'none',
                        color: '#555',
                        borderRadius: 999,
                        '&.Mui-selected': {
                            backgroundColor: '#f5f5f5',
                            color: 'black',
                        },
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                        },
                    }}
                    >
                    <ToggleButton value={0} aria-label="2d">2D</ToggleButton>
                    <ToggleButton value={50} aria-label="3d">3D</ToggleButton>
                </ToggleButtonGroup>
            </Box>
        </Box>
    );
}
